import Type from 'src/Type';
import config from 'src/utils/config';

import ValueNode from '../ValueNode';

import type Context from 'src/Context';
import type { BaseExpression, Expression, MongoId } from '../../types';

export interface ResourceNodeT extends BaseExpression {
    $type: 'ResourceNode';
    id: MongoId;
}

export default class ResourceNode extends ValueNode<ResourceNodeT> {
    static TYPE = Type.Object({
        key: 'id',
        type: 'StringNode',
        suggestions: 'external:Resource',
        forceSuggestion: true,
    });

    static uiConfig = {
        ...config.presets.default,
        style: {
            background: '#48AFF0',
            color: 'white',
        },
        description: 'Outputs the value of a resource defined in the admin UI',
    };

    static getDefault(): Expression {
        return {
            ...super.getDefault(),
            id: this.getDefaultFor('StringNode'),
        };
    }

    async execute(context: Context): Promise<any> {
        const id = await await context.evaluate(this.expression.id);
        if (!id) return null;
        const data = await context.transformation.options.fetchResource(id);
        if (!data) throw new Error(`Resource not found "${id}"`);
        return data;
    }
}
